import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';

const layoutStyle: React.CSSProperties = {
  display: 'flex',
  minHeight: '100vh',
};

const mainStyle: React.CSSProperties = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  background: '#f9fafb',
};

const contentStyle: React.CSSProperties = {
  flex: 1,
  padding: '1.5rem',
};

export const AppLayout: React.FC = () => {
  // Forced password reset is handled PRE-authentication (a must-reset account is
  // rejected at /login and routed to /change-password before any session exists),
  // so an authenticated user is never mid-reset — no guard needed here.
  return (
    <div style={layoutStyle}>
      <Sidebar />
      <div style={mainStyle}>
        <Header />
        <main style={contentStyle}>
          <ErrorBoundary>
            <Suspense fallback={<LoadingSpinner />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
};
